<template>
  <div class="garanties-list my-account-wrapper">
    <div class="clients__title">
      Factures d’entretien
      <p class="sub-title">Veuillez soumettre les factures d’entretien.</p>
    </div>

    <template v-if="isLoading">
      <Preloader />
    </template>
    <template v-else>
      <div class="garanties-filter">
        <div class="garanties-filter--wrap">
          <div class="garanties-filter__fields">
            <MultiFileInput
              v-model="document.file"
              :options="document.options"
              :allowedFileExtensions="document.allowedFileExtensions"
              :currentDocType="'maintenance_invoices'"
              :clientID="+clientId"
              @verification_documents_uploaded="onDocumentUploaded"
              :disabled="isMultiFileInputDisabled"
            />
          </div>
          <div
            class="garanties-filter__fields block__content--table docs-table"
            style="margin-top: 20px"
          >
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Nom du fichier</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="doc in docs" :key="doc.hash">
                  <td class="created">{{ formatDate(doc.created_at) }}</td>
                  <td
                    @click="openPreviewDocument(doc.hash, doc.type)"
                    class="preview-document-link"
                  >
                    {{ doc.name }}
                  </td>
                  <td>{{ formatDocStatus(doc.status) }}</td>
                  <td>
                    <font-awesome-icon
                      prefix="fas"
                      icon="trash"
                      @click="doc.status !== 'approved' && removeDocument(doc.id)"
                      :class="{ disabled: doc.status === 'approved' }"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="custom-filter__buttons">
            <button
              class="custom-filter__buttons--button"
              @click="goToDocuments"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader";
import ClientFileInput from "@/components/Clients/Documents/ClientFileInput";
import formats from "@/mixins/formats";
import MultiFileInput from "@/components/Clients/Documents/MultiFileInput";

export default {
  name: "MaintenanceInvoicesImport",
  components: { ClientFileInput, Preloader, MultiFileInput },
  mixins: [formats],
  props: [],
  data() {
    return {
      document: {
        type: "IMPORT_MAINTENANCE_INVOICE",
        title: "",
        file: [],
        options: {
          name: "Choisir un document",
          placeholder: true,
          currentFile: false,
          hash: null,
        },
        allowedFileExtensions:
          "image/jpeg, image/jpg, image/png, image/gif, application/pdf",
        status: "pending",
      },
      isLoading: false,
      status: "pending",
      docs: [],
      client_id: null,
      currentDocumentType: "maintenance_invoices",
    };
  },
  computed: {
    isApproved() {
      return this.status === "approved";
    },
    clientId() {
      return this.$route.params.id;
    },
    isMultiFileInputDisabled() {
      // Check if all documents are approved
      return this.docs.length ? this.docs.every(doc => doc.status === 'approved') : 0;
    },
  },
  watch: {
    "$store.getters.getAuthUserInfo": function (user) {},
  },
  methods: {
    getClientInfo() {
      this.isBusy = true;
      let url = `client/${this.clientId}/verification-documents`;
      this.apiGet(url)
        .then((response) => {
          this.isBusy = false;
          let docs = response.data.verification_documents || [];
          this.docs = docs.filter(
            (item) => item.type_name === this.currentDocumentType
          );
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
    onDocumentUploaded(data) {
      if (
        data.verification_documents &&
        data.verification_documents.length > 0
      ) {
        data.verification_documents.forEach((doc) => {
          this.docs.push(doc); // Add each new document to the list
        });
        this.document.file = [];
      }
    },
    openPreviewDocument(hash, type) {
      this.isBusy = true;
      let url = "verification_documents/client_file_preview";
      this.apiGet(url, {
        hash: hash,
        type: type,
      })
        .then((response) => {
          this.isBusy = false;
          console.log(response);
          if (response.data && response.data.url) {
            window.open(response.data.url);
          }
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
    goToDocuments() {
      this.$router.push(`/client/${this.clientId}/documents`);
    },
    removeDocument(id) {
      this.$confirm({
        message: "Êtes-vous sûr de vouloir supprimer ce document ?",
        button: {
          no: "NON",
          yes: "OUI",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            let url = `verification_documents/client-documents/${id}`;
            this.apiDelete(url)
              .then((response) => {
                this.getClientInfo();
                this.showSuccessNotification("Document supprimé avec succès");
              })
              .catch((error) => {
                this.isBusy = false;
                this.showErrorNotification(error);
              });
          }
        },
      });
    },
  },
  mounted() {
    this.getClientInfo();
    this.$eventBus.$emit("sidebar-set-active-tab", "Clients");
  },
};
</script>
<style>
.sub-title {
  font-size: 12px;
}
tr:first-child,
tr:last-child {
  display: table-row;
}
.disabled {
  pointer-events: stroke;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Clients/Documents/MaintenanceInvoicesImport.vue